export default {
    compententsApi: {
        select: 'Please select audit data',
        selectorder: 'Please select the order to be approved',
        permissions: 'You do not have sufficient permissions to approve the selected order',
        passed: 'Whether the after-sales order has passed the audit',
        review: 'Whether to refuse to review the after-sales order',
        rejected: 'Approval rejected',
        reason: 'Please enter a rejection reason',
        Please: 'Please enter',
    }
};
